import React, {Component} from 'react';

import InputField from './InputField';
import ImageField from './ImageField';

import './PersonaHeader.scss';

const userImages = [
  '/user-blank.png',
  '/user-sean.png',
  '/user-ricky.png',
  '/user-1.png',
  '/user-2.png',
  '/user-3.png',
  '/user-4.png',
  '/user-5.png',
  '/user-6.png',
  '/user-7.png',
  '/user-8.png',
  '/user-9.png'
];

export default class PersonaHeader extends Component {
  render() {
    return (
      <div className="persona-info-container col-xs">
        <div className="row persona-info">
          <div className="col-sm-12 col-md-8 persona-meta">
            <InputField
              hideLabel={true}
              formKey="name"
              placeholder="Name"
              {...this.props}
            />
            <InputField
              formKey="age"
              placeholder="Actual age or range"
              {...this.props}
            />
            <InputField
              formKey="residence"
              placeholder="State, city, or even neighborhood"
              {...this.props}
            />
            <InputField
              formKey="education"
              placeholder="Highest level of education or training"
              {...this.props}
            />
            <InputField
              formKey="occupation"
              placeholder="Job or primary way of making money"
              {...this.props}
            />
            <InputField
              formKey="marital_status"
              placeholder="Married, single, with kids, without"
              {...this.props}
            />
          </div>
          <div className="col-sm col-md-4 persona-image-wrapper">
            <ImageField formKey="persona_image" images={userImages} {...this.props}/>
          </div>
        </div>
        <div className="row persona-quote">
          <div className="col-md">
            <InputField
              hideLabel={true}
              formKey="quote"
              placeholder="A quote from to help define their voice and personality."
              {...this.props}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/PersonaHeader.jsx